import { html } from 'lit';
import type { ParticipationOverviewPlugin } from '../plugin-types.js';
import { defaultGetDropdownActions, defaultParticipationOverviewPlugin } from './default.js';

export const icsrmParticipationOverviewPlugin: ParticipationOverviewPlugin = {
  id: 'participation-overview::icsrm',
  type: 'participation-overview',
  getDropdownItemActions: defaultGetDropdownActions,
  getColumnDefinitions: (host, product, coloring, paymentActive, participationState, extraColumns) => {
    const customColumns = defaultParticipationOverviewPlugin.getColumnDefinitions(
      host,
      product,
      coloring,
      paymentActive,
      participationState,
      extraColumns,
    );
    const herkunftslandColumnDefinition = {
      columnName: 'Herkunftsland',
      fieldName: 'buyer.stammdaten.countryOfBirth',
      isSortable: true,
      renderItem: instance => html` <tr-text>${instance.buyer?.stammdaten?.countryOfBirth ?? '-'}</tr-text>`,
    };

    // insert herkunftsland column
    customColumns.splice(4, 0, herkunftslandColumnDefinition);

    return customColumns;
  },

  getCSVFieldsForExport: async stammdatenFields => {
    const fields = await defaultParticipationOverviewPlugin.getCSVFieldsForExport(stammdatenFields);
    const nachNameIndex = fields.findIndex(field => field.input === 'Nachname');
    const countryField = { input: 'Land', output: 'stammdaten.countryOfBirth' };
    fields.splice(nachNameIndex + 1, 0, countryField); // insert country field after Nachname
    return fields;
  },
};
